import React, {Component} from 'react';
import PropTypes from 'prop-types';
// import Grid from '@material-ui/core/Grid';
// import arrow from '../../images/icons8-down.svg';

class RenderRankHeader extends Component {
  render() {
    return(
      <div 
        className={'header-cell pt2 pb2 ' + (this.props.activeSort < 0 ? 'active' : '')} 
        style={this.props.args.style} 
        role="row"
        justify="center"
        onClick={this.props.updateSort.bind(this, -1)}>
        <div className="title"> 
          <p className="ma0 subtext  fw5">
            <span className={(this.props.activeSort < 1 ? '' : '')}>Points</span> 
          </p>
        </div>
        {/*<div className="fw4">
          <Grid 
            spacing={0}
            container>
            <Grid 
              xs={6} 
              item
              className="tc">
               <p className="ma0 subtext">Rank</p>
            </Grid>
            <Grid 
              xs={6} 
              item>
               <p className="ma0 subtext">Points</p>
            </Grid>
          </Grid>
        </div>*/}
      </div>
    )
  }
}

RenderRankHeader.propTypes = {
  args: PropTypes.object.isRequired,
  activeSort: PropTypes.number.isRequired,
  updateSort: PropTypes.func.isRequired
}

export default RenderRankHeader;